import { useTranslate } from 'hooks/use-translate';
import { useCallback } from 'react';
import { ControllerFieldState, ControllerRenderProps } from 'react-hook-form';
import { transformFieldToLabelKey } from 'utils/transformers';

export type FieldRenderProps = {
  field: ControllerRenderProps<any, any>;
  fieldState: Pick<ControllerFieldState, 'error'>;
};
type Options = {
  emptyHelperText?: string;
};
type RenderOptions = {
  label: string;
};
export const useFieldProps = (options: Options = { emptyHelperText: ' ' }) => {
  const { t } = useTranslate();

  const emptyHelperText = options.emptyHelperText;

  return useCallback(
    (renderProps: FieldRenderProps, renderOptions?: RenderOptions) => {
      const { field, fieldState } = renderProps;
      const error = fieldState.error;
      return {
        ...field,
        label:
          renderOptions?.label === undefined
            ? t(transformFieldToLabelKey(field.name))
            : renderOptions.label,
        error: Boolean(error),
        helperText: error && error.message ? t(error.message) : emptyHelperText,
      };
    },
    [t, emptyHelperText],
  );
};
